import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import LoggedAction from 'src/app/model/logged-action';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SetSubProjectOnHoldControllerRequestService {
  private static BASE_URL = '/subprojects';
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as LoggedAction;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      SetSubProjectOnHoldControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public setSubProjectOnHold(
    subProjectId: number,
    onHoldReason: string
  ): Promise<LoggedAction> {
    return this.post(
      '/setOnHold',
      {
        subProjectId: subProjectId,
        onHoldReason: onHoldReason,
      },
      this.deserialize
    ).toPromise();
  }
}
